export default __webpack_public_path__ + "static/media/mehrangarhfort.7d1ed894.jpg";